import React, {useEffect, useState} from "react";
import Select from "react-select";
import customStyles from "../../assets/select/customStyles";
import SettingsPanelDateTimeSpanSelector from "../CommonComponents/SettingsPanelDateTimeSpanSelector";
import SimpleBar from "simplebar-react";
import axios from "axios";

function ReservierungsListeFilter({ translation, filterOptions, filterOptionsChanged, searchTextChanged }) {
    const link = localStorage.getItem('link') + '/api/ReservationService';
    const userDepartmentId = parseInt(localStorage.getItem("departmentId"));
  
    const [selectedDepartment, setSelectedDepartment] = useState(filterOptions.department);
    const [departments, setDepartments] = useState([]);
    const [selectedFrom, setSelectedFrom] = useState(filterOptions.from);
    const [selectedTill, setSelectedTill] = useState(filterOptions.till);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
        loadData();
    }, []);

    const loadData = () => {
        axios.get(link + '/DepartmentSelections', {}).then((response) => {
            let departments = response.data;
            departments.unshift({value: null, label: translation("allgemein.alle")});
            setDepartments(departments);

            if (filterOptions.department == null) {
                const _userDepartment = departments.find(department => department.value === userDepartmentId);
                setSelectedDepartment(_userDepartment);
                filterOptionsChanged(prev => ({...prev, department: _userDepartment}));
                console.log("userDepartment", _userDepartment);
            }
        })
            .catch((error) => {
                console.error("Error while loading Data", error);
            });
    }

    return (
        <div className="content-group">
            <div className="content-group-name" style={{marginBottom: '0px'}}>
                {translation("allgemein.filter")}
            </div>
            <SimpleBar className="simplebar-se">
                <div className="content-group" style={{width: '100%'}}>
                    <div className="content-group-name">
                        {translation("userDepartments.department")}
                    </div>
                    <div className="typ-container-se">
                        <Select
                            styles={customStyles}
                            closeMenuOnSelect={true}
                            isSearchable={false}
                            isMulti={false}
                            onChange={(department) => {
                                console.log("selectedDepartment changed", department);
                                setSelectedDepartment(department);
                                filterOptionsChanged(prev => ({ ...prev, department: department }));
                            }}
                            options={departments}
                            value={selectedDepartment}
                        />
                    </div>
                </div>

                <div className="content-group" style={{width: '100%'}}>
                    <div className="content-group-name">
                        {translation("allgemein.suchen")}
                    </div>
                    <div className="typ-container-se">
                        <input
                            type="text"
                            style={{width: '100%'}}
                            placeholder={translation("allgemein.suchen")}
                            value={searchText}
                            onChange={(e) => {setSearchText(e.target.value); searchTextChanged(e.target.value);}}
                        ></input>
                    </div>
                </div>

                <SettingsPanelDateTimeSpanSelector
                    translation={translation}
                    initialFrom={selectedFrom}
                    initialTill={selectedTill}
                    fromDateChanged={(value) => setSelectedFrom(value)}
                    tillDateChanged={(value) => setSelectedTill(value)}
                    sendButtonClicked={(from, till) => filterOptionsChanged(prev => ({ ...prev, from: selectedFrom, till: selectedTill }))}
                />
            </SimpleBar>
        </div>
    );
}

export default ReservierungsListeFilter;
